import { useEffect, useState } from "react";
import api from "./api";

// Cache simple a nivel módulo para no re-pedir en cada montaje
let _cache = null;
const _subs = new Set();

async function _fetch() {
  try {
    const { data } = await api.get("/sucursales");
    _cache = data;
    _subs.forEach((fn) => fn(data));
  } catch {
    // Página pública (login/registro sin sesión): usar el listado público de sucursales activas
    try {
      const { data } = await api.get("/sucursales/publico");
      _cache = data;
      _subs.forEach((fn) => fn(data));
    } catch { /* ignore */ }
  }
}

// Devuelve la lista de sucursales (admin ve todas; otros roles sólo activas)
export function useSucursales() {
  const [sucursales, setSucursales] = useState(_cache || []);
  useEffect(() => {
    if (_cache) setSucursales(_cache);
    _subs.add(setSucursales);
    if (!_cache) _fetch();
    return () => _subs.delete(setSucursales);
  }, []);
  return sucursales;
}

// Sólo activas, útil para selectores de creación
export function useSucursalesActivas() {
  const all = useSucursales();
  return all.filter((s) => s.activa !== false);
}

export function refreshSucursales() { return _fetch(); }
